module.exports = __webpack_public_path__ + "static/media/LQ_Embroidery_Meda_Ind.Blue_Peri.eb962d35.png";